import React from 'react';

const Hardware: React.FC<React.PropsWithChildren> = () => (
  <>
    <path d="M6 18.5H18V6.5H6V18.5ZM14 20.5H10V22.5H8V20.5H5C4.73478 20.5 4.48043 20.3946 4.29289 20.2071C4.10536 20.0196 4 19.7652 4 19.5V16.5H2V14.5H4V10.5H2V8.5H4V5.5C4 5.23478 4.10536 4.98043 4.29289 4.79289C4.48043 4.60536 4.73478 4.5 5 4.5H8V2.5H10V4.5H14V2.5H16V4.5H19C19.2652 4.5 19.5196 4.60536 19.7071 4.79289C19.8946 4.98043 20 5.23478 20 5.5V8.5H22V10.5H20V14.5H22V16.5H20V19.5C20 19.7652 19.8946 20.0196 19.7071 20.2071C19.5196 20.3946 19.2652 20.5 19 20.5H16V22.5H14V20.5ZM8 8.5H16V16.5H8V8.5Z" />
  </>
);

export default Hardware;
